import Text from "./Text"
import TIcon from "./TIcon";
const Table = ({ headerRow = [], columnValues = [] }) => {

    const FeatureValue = ({ value }) => {
        if (value === true) {
            return (
                <div className="flex justify-center">
                    <TIcon name="check" size={20} color="green" stroke={2} />
                </div>
            );
        }
        if (value === false) {
            return (
                <div className="flex justify-center">
                    <TIcon name="x" size={20} color="gray" stroke={2} />
                </div>
            );
        }
        return (
            <Text type="itemtext" classNames="font-medium text-center">
                {value}
            </Text>
        );
    };

    return (
        <div className="w-full bg-white rounded-lg shadow-md mt-6">
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead className="bg-gray-100">
                        <tr>
                            {headerRow.map((header, index) => (
                                <th
                                    key={index}
                                    className={`px-6 py-4 ${index === 0 ? "text-left" : "text-center"
                                        }`}
                                >
                                    <Text type="subtitle">{header}</Text>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {columnValues.map((row, rowIndex) => (
                            <tr key={rowIndex} className="hover:bg-gray-50">
                                {row.map((cell, cellIndex) => (
                                    <td
                                        key={cellIndex}
                                        className={`px-6 py-4 ${cellIndex === 0 ? "text-left" : "text-center"
                                            }`}
                                    >
                                        {cellIndex === 0 ? (
                                            <Text type="itemtext">{cell}</Text>
                                        ) : (
                                            <FeatureValue value={cell} />
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default Table